module.exports = __webpack_public_path__ + "img/34-Breakouts.ac47c46e.png";